const WASM_BASE =
  (process.env.VITE_WITC_WASM_BASE ?? '/wasm/witc').replace(/\/$/, '');

type WitcAesGcmDecryptFn = (
  packedBase64: string,
  keyBase64: string
) => Promise<string>;

interface WitcCryptoGlobal {
  __witcAesGcmDecrypt?: WitcAesGcmDecryptFn;
}

function witcCryptoGlobal(): WitcCryptoGlobal {
  return globalThis as WitcCryptoGlobal;
}

let cryptoHelperLoaded = false;

async function ensureWitcCryptoHelper(): Promise<void> {
  const g = witcCryptoGlobal();
  if (cryptoHelperLoaded && g.__witcAesGcmDecrypt) return;
  await import(/* webpackIgnore: true */ `${WASM_BASE}/witc-crypto.js`);
  if (!witcCryptoGlobal().__witcAesGcmDecrypt) {
    throw new Error('WITC crypto helper failed to load.');
  }
  cryptoHelperLoaded = true;
}

/** Decrypt server bootstrap cipher via Web Crypto (AES-GCM). Returns base64 plaintext for WASM. */
export async function decryptWitcBootstrapCipher(
  cipherBase64: string,
  keyBase64: string
): Promise<string> {
  await ensureWitcCryptoHelper();
  const decrypt = witcCryptoGlobal().__witcAesGcmDecrypt;
  if (!decrypt) {
    throw new Error('WITC crypto helper failed to load.');
  }
  return decrypt(cipherBase64, keyBase64);
}
